import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

Vue.use(Vuex)

const defaultState = {
        employees: [],
        searchSortDetails: {},
        workSortDetails: {},
}

export const store = new Vuex.Store( {

    plugins: [
        createPersistedState({
            storage: {
              getItem: (key) => ls.get(key),
              setItem: (key, value) => ls.set(key, value),
              removeItem: (key) => ls.remove(key),
            },
          }),
    ],

    state: defaultState,

    actions: {
        loadEmployees({commit, state}) {
            if (state.employees.length === 0) {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/meta/employee/all`)
                    .then((response) => {
                        commit('SET_EMPLOYEES', response.data)
                    }).catch((error) => {
                    console.log(error)
                })
            }
        },
        loadSearchSortDetails({commit, state}, sortDetails){
            commit('SET_SEARCH_SORT_DETAILS',sortDetails)
        },
        loadWorkSortDetails({commit, state}, sortDetails){
            commit('SET_WORK_SORT_CRITERIA',sortDetails)
        },

        resetState({commit}) {            
            commit('RESET_STATE')
        }

      },

      mutations: {
        SET_EMPLOYEES(state, employees) {
            state.employees = employees
        },
        SET_SEARCH_SORT_DETAILS(state,sortDetails){
            state.searchSortDetails[sortDetails.key] = sortDetails.settings
        },
        SET_WORK_SORT_CRITERIA(state,sortDetails){
            state.workSortDetails = sortDetails
        },
        RESET_STATE(state) {
            Object.assign(state, defaultState)
        }
      },
    
} )
